import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import "./TeacherHome.css";
import TeacherCreateClass from "../../Components/TeacherCreateClass/TeacherCreateClass";
import CreatedVideos from "../../Components/CreatedVideos/CreatedVideos";
import Footer from "../../Components/Footer/Footer";
import TeacherAnalytics from "../../Components/TeacherAnalytics/TeacherAnalytics";
import AccountSetting from "../AccountSetting/AccountSetting";
import { useLocation } from 'react-router-dom';

function TeacherHome() {
  const [value, setValue] = useState(0);
   const location = useLocation();
   const { userId, name } = location.state || {};
  
  const handleChange = (event, newValue) => {
    setValue(newValue); 
  };

  return (
    <div className="teacher-home-container">
      <div className="tabs-wrapper">
        {/* Material-UI Tabs */}
        <Tabs
          value={value}
          onChange={handleChange}
          centered
          sx={{
            borderRadius: "12px", 
            border: "1px solid #d9d9d9", 
            backgroundColor: "#fff",
            padding: "8px", 
          }}
        >
          <Tab label="Create Class" />
          <Tab label="Classes" />
          <Tab label="Sessions" />
          <Tab label="Analytics" />
          <Tab label="Account Settings" />
        </Tabs>

        {/* Tab Content */}
        <Box>
          {value === 0 && <TeacherCreateClass userId={userId} name={name}/>}
          {value === 1 && <CreatedVideos userId={userId}/>}
          {value === 2 && <CreatedVideos />}
          {value === 3 && <TeacherAnalytics />}
          {value === 4 && <AccountSetting />}
        </Box>
      </div>
      <Footer />
    </div>
  );
}

export default TeacherHome;